import { ATTRS, PRODUCT_TYPES, TAGS } from '../constants';
import { EntitiesManager } from '../entitiesManager';
import { Entity, ISOFileInformation } from '../types';
import { ProductRelationEntity } from './ProductRelation';

export class ProductEntity implements Entity {
  public static fromXML(
    xml: any,
    matchIDs: any,
    files: ISOFileInformation[],
    entitiesManager: EntitiesManager
  ) {
    const attrs = xml._attributes;
    const isoId = attrs[ATTRS.Product.ProductId];
    const id = matchIDs[isoId] ? matchIDs[isoId].id : null;

    const productRelations = (xml[TAGS.ProductRelation] || []).map((relation) => {
      return ProductRelationEntity.fromXML(relation, matchIDs, files, entitiesManager);
    });

    return {
      entity: new ProductEntity(
        id,
        attrs[ATTRS.Product.ProductDesignator],
        attrs[ATTRS.Product.QuantityDDI],
        attrs[ATTRS.Product.ProductType],
        attrs[ATTRS.Product.MixtureRecipeQuantity],
        productRelations
      ),
      isoId,
    };
  }
  public type = TAGS.Product;
  public id: string;

  constructor(
    id: string,
    public title: string,
    public quantityDDI: string,
    public productType: string = PRODUCT_TYPES.Single,
    public mixtureRecipeQuantity?: number,
    public productRelations: Array<ProductRelationEntity> = []
  ) {
    this.id = id;
  }

  public toXML(xmlId: string, entityManager: EntitiesManager) {
    return {
      _attributes: {
        [ATTRS.Product.ProductId]: xmlId,
        [ATTRS.Product.ProductDesignator]: this.title,
        [ATTRS.Product.QuantityDDI]: this.quantityDDI,
        ...(entityManager.options.version === 4 && {
          [ATTRS.Product.ProductType]: this.productType,
          [ATTRS.Product.MixtureRecipeQuantity]: this.mixtureRecipeQuantity,
        }),
      },
      ...(entityManager.options.version === 4 && {
        [TAGS.ProductRelation]: (this.productRelations || []).map((relation) =>
          relation.toXML(null, entityManager)
        ),
      }),
    };
  }
}
